// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"283517d0","180":"1d87f481","264":"de9687b2","421":"4c67c0d5","453":"4c577da7","619":"11c67e2c","787":"f36778c5"}[chunkId] + ".chunk.js";
};